module.exports = __webpack_public_path__ + "fonts/icomoon.b1ddad1.eot";